import { Outlet } from 'react-router-dom'

export const handle = {
  title: `Online Scheduler`,
  breadcrumb: `Online Scheduler`,
}

export default function OnlineScheduler(): React.ReactElement {
  return <Outlet />
}
